module.exports = __webpack_public_path__ + "img/renew.png?e74544e9ae91da33c55249c9e861f0fb";